import {Carousel} from 'extensions/carousel';

export default class SpecsSliders {

	constructor (element) {
		this.element = element;
		this.imageSliderElem = this.element.querySelector('.js-component-lp-specs-slider__images');
		this.imageSliderSlides = this.imageSliderElem.getElementsByClassName('js-component-lp-specs-slider-slide__image');
		this.textSliderElem = this.element.querySelector('.js-component-lp-specs-slider__text');
		this.arrowsElem = this.element.querySelector('.js-component-lp-specs-slider__arrows');
		this.titles = [];

		if (this.element.classList?.contains?.('component-lp-specs-slider--single')) {
			return;
		}

		this.init();
	}

	init () {

		this.getTitles();
		this.initSliders();

	}

	getTitles () {
		for (const slide of this.imageSliderSlides) {
			this.titles.push({
				long: slide.getAttribute('data-long-title'),
				short: slide.getAttribute('data-short-title')
			});
		}
	}

	initSliders () {
		if (!this.imageSliderElem || !this.textSliderElem) {
			return;
		}

		this.initTextSlider();
	}

	initTextSlider () {
		this.textSlider = new Carousel(this.textSliderElem, {
			arrows: false,
			autoHeight: false,
			breakpoints: {
				959: {
					autoHeight: true
				}
			},
			gap: '2px',
			isNavigation: true,
			keyboard: 'focused',
			pagination: true,
			perPage: 1,
			rewind: true,
			type: 'loop'
		});

		if (this.textSlider.slider) {
			this.textSlider.slider.on('pagination:mounted', (data) => {
				// eslint-disable-next-line array-element-newline
				for (const [index, item] of data?.items?.entries?.()) {
					item.button.textContent = this.titles?.[index]?.short || '';
				}
			});

			this.textSlider.slider.mount();
		}

		this.initImageSlider(this.textSlider);
	}

	initImageSlider (textCarousel) {
		this.imageSlider = new Carousel(this.imageSliderElem, {
			arrows: true,
			gap: 0,
			keyboard: 'focused',
			pagination: false,
			perPage: 1,
			rewind: true,
			type: 'loop'
		});

		if (this.imageSlider.slider) {
			this.imageSlider.slider.on('moved', (newIndex) => {
				this.updateArrows(newIndex);
			});

			this.imageSlider.slider.sync(textCarousel.slider).mount();
		}

		this.updateArrows(0);
		this.moveArrows();
	}

	updateArrows (newIndex) {
		const slideCount = this.imageSlider.slider?.length - 1;
		const prevIndex = newIndex === 0 ? slideCount : newIndex - 1;
		const nextIndex = newIndex === slideCount ? 0 : newIndex + 1;

		const prevArrow = this.imageSlider?.slider?.Components?.Arrows?.arrows?.prev?.querySelector('.component-lp-specs-slider__arrow-text') || null;
		if (prevArrow) {
			prevArrow.textContent = this.titles?.[prevIndex]?.long;
		}

		const nextArrow = this.imageSlider?.slider?.Components?.Arrows?.arrows?.next?.querySelector('.component-lp-specs-slider__arrow-text') || null;
		if (nextArrow) {
			nextArrow.textContent = this.titles?.[nextIndex]?.long;
		}
	}

	moveArrows () {
		const prevArrow = this.imageSliderElem.querySelector('.g-carousel__arrow--prev');
		const nextArrow = this.imageSliderElem.querySelector('.g-carousel__arrow--next');

		if (prevArrow) {
			this.arrowsElem.appendChild(prevArrow);
		}

		if (nextArrow) {
			this.arrowsElem.appendChild(nextArrow);
		}
	}

}
